var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"check-box-wrap"},[_c('input',{attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isCheck},on:{"change":_vm.onCheckChanged}}),_c('span',{staticClass:"check-icon"}),_c('span',{staticClass:"check-label"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }